





































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IPayment } from '@/store/modules/views/payment/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IBank } from '@/store/modules/components/states'

@Component
export default class EditPaymentDialog extends VueExtendedBaseComponent {

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  @Getter('components/banks')
  private banks: IBank[]

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get editPaymentDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.editPaymentAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get validateInput() {

    return this.nameValidate(this.name)
  }
  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private payment!: IPayment & {roles: string[], permissions: string[], accounts: string[]}
  private loading = false
  private urlPayment = ''

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private valid = false
  private name = ''
  private bank: {name: string, text: string} = null
  private accountNumber = ''
  private centeritems!: string
  private urlPaymentCenter = ''

  @Action('center/getCenterList')
  private getCentertList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  get centerLists() {
    return this.centerItemLists
  }

  public async getPaymentCenter() {
    return await HttpRequestServiceWithToken
      .get(this.urlPaymentCenter, {}, ( response: { name: string, _id: string }) => {
        this.centeritems = response._id
        return response
      })
  }

  private requireSelect(value) { return [(v) => !!v || 'ข้อมูลจำเป็นต้องเลือก'] }

  private async created() {
    this.name = this.payment.name || ''
    this.accountNumber = this.payment.accountNumber  || ''
    this.bank = _.find(this.banks, {name: this.payment.bank}) || null
    this.urlPayment = `${process.env.VUE_APP_API_URL}/v1/all/payment/${this.payment._id}`
    this.urlPaymentCenter = `${process.env.VUE_APP_API_URL}/v1/all/center/${this.payment.centerId}`
    this.centeritems = this.payment.centerId
    await Promise.all([
      this.getPaymentCenter(),
      this.getCenterListFunc(),
    ])
  }

  private async getCenterListFunc() {
    await this.getCentertList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private requireInput(value) {  return value !== '' || 'จำเป็นต้องกรอก' }

  get invalidateInput() {
    return _.some(
        [
        ],
        (item) => item !== true,
    )
  }

  private async editPaymentAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const paymentData = {
        edit: {
          name: this.name,
          accountNumber: this.accountNumber,
          bank: this.bank.name,
          centerId: this.centeritems,
        },
      }
      try {
        await Promise.all([
          HttpRequestServiceWithToken.put(this.urlPayment, paymentData.edit),
        ])
        this.updateSnackbar({txt: 'แก้ไขข้อมูลสำเร็จ', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      } catch (e) {
        this.loading = false
      }
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
